export default {"src":"/_next/static/image/public/images/ic_btn_arrow.9f29cdf89c134286e338f395b70edfa6.svg","height":8,"width":13};